import { X, Plus } from "lucide-react";
import { FIELD_TYPES, ROLE_PALETTE, ACCENT } from "../../../../constants/formflow/fieldTypes";

export function BuilderLeftPanel({ form, setForm, activeRole, setActiveRole, activeType, setActiveType, addRole, removeRole }) {
  return (
    <div style={{ width: 232, background: "white", borderRight: "1px solid #e5e7eb", display: "flex", flexDirection: "column", overflow: "hidden", flexShrink: 0 }}>
      {/* Roles Section */}
      <div style={{ padding: "14px 14px 10px", borderBottom: "1px solid #f3f4f6" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 0.8 }}>Roles</span>
          {form.roles?.length < 5 && (
            <button onClick={addRole} style={{ background: "none", border: "none", cursor: "pointer", color: ACCENT, fontSize: 20, lineHeight: 1, padding: 2, borderRadius: 4 }}>
              <Plus size={14} />
            </button>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {form.roles?.map((role, idx) => {
            const c = ROLE_PALETTE[idx % ROLE_PALETTE.length];
            const isActive = activeRole === role.id;
            return (
              <div
                key={role.id}
                onClick={() => setActiveRole(role.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "7px 10px",
                  borderRadius: 8,
                  cursor: "pointer",
                  background: isActive ? c.bg : "transparent",
                  border: isActive ? `1.5px solid ${c.border}` : "1.5px solid transparent",
                  transition: "all 0.15s",
                }}
              >
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: c.dot, flexShrink: 0 }} />
                <input
                  value={role.name}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) =>
                    setForm((f) => ({
                      ...f,
                      roles: f.roles.map((r) => (r.id === role.id ? { ...r, name: e.target.value } : r)),
                    }))
                  }
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontSize: 13,
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? c.text : "#374151",
                    flex: 1,
                    minWidth: 0,
                  }}
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeRole(role.id);
                  }}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#d1d5db", padding: 2, display: "flex" }}
                >
                  <X size={12} />
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Field Types Section */}
      <div style={{ padding: "14px", flex: 1, overflowY: "auto" }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 10 }}>Field Types</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {FIELD_TYPES.map((ft) => {
            const isA = activeType === ft.id;
            const dotC = form.roles?.findIndex((r) => r.id === activeRole);
            const ac = ROLE_PALETTE[Math.max(0, dotC) % ROLE_PALETTE.length];
            return (
              <button
                key={ft.id}
                onClick={() => setActiveType(isA ? null : ft.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "9px 12px",
                  borderRadius: 8,
                  border: isA ? `1.5px solid ${ac.border}` : "1.5px solid transparent",
                  background: isA ? ac.bg : "transparent",
                  cursor: "pointer",
                  textAlign: "left",
                  transition: "all 0.15s",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: isA ? ac.dot : "#f3f4f6",
                    color: isA ? "white" : "#6b7280",
                    transition: "all 0.15s",
                    flexShrink: 0,
                  }}
                >
                  <ft.Icon size={14} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 500, color: isA ? ac.text : "#374151" }}>{ft.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
